import { ListOptions } from 'common/types/extractOnboardingQuestions.types'

const extractOnboardingQuestions = ({ listOfQuestions = [], q = '' }: ListOptions) => {
  let ans = undefined
  if (!listOfQuestions.length && !q) return undefined
  listOfQuestions.map(({ question, answer }) => {
    if (question === q.trim()) {
      ans = answer
      return
    }
  })
  return ans
}

export default extractOnboardingQuestions
